import { AbstractPopUp } from './AbstractPopUp';
import { createButton, translate } from '../utils/GameEngine';
import { Button } from '../UI/elements/buttons/Button';
import { Events } from '../core/Events';

export class EndPopup extends AbstractPopUp {
    private resetButton: Button;

    protected drawLayout(params?: any): void {
        super.drawLayout(params);
        this.image.scale.set(0.7, 0.7);
        this.resetButton = createButton(
            'green_btn_large@2x',
            this,
            (): void => {
                dispatchEvent(new CustomEvent(Events.startOver));
            },
            translate('Start over', true),
            true,
            true,
            1
        );
        this.resetButton.position.set(390, 460);
    }
}